import React, {Component} from 'react';
import {Redirect} from 'react-router';
import queryString from 'query-string';

import { deviceService, userService } from '../../services';
import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import Detailview from '../../components/Detailview/Detailview';

import './Report.css';

class Report extends Component{
    state = {
        redirect: false,
        cluster: null,
        error: '',
        start:  null,
        end: null
    };

    componentDidMount(){
        const params = queryString.parse(this.props.location.search);

        if (params.cluster !== undefined && params.period !== undefined){
            this.getClusterDevices(params.cluster, params.period);
            
            return;
        }
        this.setState({
            redirect: true
        })
    }

    setDate = (dateString) => {
        const d = dateString.split('/');
        const year = Number(d[2]);
        const month = Number(d[1]);
        const day = Number(d[0]);
        const date = new Date(year, month, day);

        date.setMonth(date.getMonth() - 1)
        return date;
    }

    getClusterDevices = async (clusterID, queryDateRange) => {
        try{
            const dates = queryDateRange.split('|');
            const startDate = this.setDate(dates[0]);
            const endDate = this.setDate(dates[1]);
            let cluster = await userService.getUserCluster(clusterID);
            let res = await userService.getUserClusterDevices(clusterID);
            
            // search dates are exclusive so move end back by 1 day
            endDate.setDate(endDate.getDate() - 1);
            // and set start start of week - Monday
            startDate.setDate(startDate.getDate() - startDate.getDay() + 1);
            cluster.devices = res.devices;
            // for(let i = 0; i < cluster.devices.length; i++){
            //     const deviceId = cluster.devices[i].id;
                
            //     res = await deviceService.updateDevice(deviceId, queryDateRange);
            //     cluster.devices[i].data = res.data;
            //     cluster.devices[i].stats = deviceService.calcStats(res.data, startDate);
            // }
            let deviceIDs = '';
            for(let i = 0; i < cluster.devices.length; i++){
                if (i > 0)
                    deviceIDs += ',';
                deviceIDs += cluster.devices[i].id;
            }
            res = await deviceService.getDevicesData(deviceIDs, queryDateRange);
            for(let i = 0; i < cluster.devices.length; i++){
                cluster.devices[i].data = res.devices[i].data;
                cluster.devices[i].stats = deviceService.calcStats(res.devices[i].data, startDate);
            }
            this.sortClusterDevices(cluster);
            this.setState({
                cluster: cluster,
                start: startDate,
                end: endDate
            });
        }
        catch(err) {
            console.log(err);
            this.setState({
                error: 'Error creating report: ' + err
            });
        }
    }

    arrayMove = (arr, old_index, new_index) => {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    };

    sortClusterDevices = (cluster) => {
        let mapped = cluster.devices.map((e, i) => {
            return {index: i, value: e.name};
        });

        // Sort alphabetically
        mapped.sort((a, b) => {
            return a.value.localeCompare(b.value);
        });
        
        // Sort according to preference
        if (cluster.uiConfig != null){
            try{
                const uiConfig = JSON.parse(cluster.uiConfig);

                if (uiConfig.buzzCSA){
                    if (uiConfig.buzzCSA.buttonOrder){
                        for (let i = 0; i < uiConfig.buzzCSA.buttonOrder.length; i++){
                            for (let j = 0; j < mapped.length; j++){
                                if (uiConfig.buzzCSA.buttonOrder[i].localeCompare(mapped[j].value) 
                                    === 0){
                                    this.arrayMove(mapped, j, i);
                                }
                            }
                        }
                    }
                }
            }
            catch(err) {
                console.log(err);
            }
        }

        // Build correct order
        let result = mapped.map((e) => {
            return cluster.devices[e.index];
        });
        cluster.devices = result;
    }

    render(){
        let pages = null;
        
        console.log(this.props);
        console.log(this.state);
        if (this.state.redirect){
            pages = <Redirect to='/login'/>;
        }
        else if (this.state.cluster !== null){
            pages = this.state.cluster.devices.map((v, i) => {
                return (
                    <div key={i} className='page portrait'>
                        {i === 0 ? 
                            <h1 style={{textAlign:'center'}}>
                                {this.state.cluster.name}
                            </h1> 
                        : 
                            null
                        }
                        {i === 0 ? 
                            <h2>
                                From: {this.state.start.toDateString()} to {this.state.end.toDateString()}
                            </h2> 
                        : 
                            null
                        }
                        <Detailview
                            device={v} 
                            uiConfig={null}
                            weekStartDate={this.state.start}
                            dash={false}
                        />
                    </div>
                );
            });
        }
        window.isReadyForPDF = this.state.cluster !== null;

        return (
            <Auxiliary>
                {pages}
            </Auxiliary>
        );
    }
}

export default Report;